import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Store} from "@ngxs/store";
import {Observable} from "rxjs";
import {GetAccountStatusAction} from "../actions/account.actions";
import { GetUserBankListAction } from "../actions/bank.actions";

@Injectable({ providedIn: 'root' })
export class BankAccountsResolver  {
  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.store.dispatch(new GetUserBankListAction())
  }
}
